import React, { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import AuthLayout from "../components/AuthLayout"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"

const VerifyEmail = () => {
  const { userId, token } = useParams()
  const [status, setStatus] = useState({ loading: true, success: false, message: "" })

  useEffect(() => {
    const verify = async () => {
      if (!userId || !token) {
        setStatus({ loading: false, success: false, message: "Invalid verification link" })
        return
      }

      try {
        const url = `${getAPIBaseURL()}/v1/users/verify-email/${userId}/${token}`
        const res = await getData(url, {}, {})

        if (res.error === "") {
          if (res.result.status === 200) {
            setStatus({ loading: false, success: true, message: res.result.data?.data || "Email verified successfully" })
          } else {
            setStatus({ loading: false, success: false, message: res.result.data?.message || "Verification failed" })
          }
        } else {
          setStatus({ loading: false, success: false, message: res.result?.data?.message || "Verification failed" })
        }
      } catch (error) {
        setStatus({ loading: false, success: false, message: "Network error. Please try again later." })
      }
    }

    verify()
  }, [userId, token])

  return (
    <AuthLayout
      title="Verify your employer account"
      subtitle="We’re confirming the email address for your Employ Me employer account."
    >
      <div className="space-y-6">
        {status.loading ? (
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
            Verifying your email...
          </div>
        ) : status.success ? (
          <div className="rounded-lg border border-green-200 bg-green-50 p-4 text-sm font-medium text-green-700">
            {status.message || "Your employer email has been verified successfully."}
          </div>
        ) : (
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-medium text-red-700">
            {status.message || "Email verification failed. The link may be invalid or expired."}
          </div>
        )}

        {!status.loading && (
          <div className="text-center">
            <p className="mb-3 text-xs text-gray-500">
              You can now sign in to manage your jobs, applicants, and company profile.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center justify-center rounded-lg bg-[#00A5E6] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#008FCC] focus:outline-none focus:ring-4 focus:ring-[#cceffd]"
            >
              Proceed to employer login
            </Link>
          </div>
        )}
      </div>
    </AuthLayout>
  )
}

export default VerifyEmail

